export function shallowCompareArrays(x, y) {
    if (x.length !== y.length) {
        return false;
    }
    return x.every(function (value, i) { return y[i] === value; });
}
//# sourceMappingURL=shallowCompareArrays.js.map